import { RouterView, type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import { h } from "vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/feed",
    name: ROUTE_NAME.FEED,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.FEED_LIST },
    children: [
      {
        path: "",
        name: ROUTE_NAME.FEED_LIST,
        component: () => import("./views/FeedListView.vue"),
      },
    ],
  },
];
